import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';

import { freeBetStore } from '../../../store/freeBetStore';
import { applicationStore } from '../../../store/applicationStore';

import FreeBet from '../../../components/common/freeBet';

const FreeBetWrapper = observer(() => {
  const { isShowFreeBetPopup } = freeBetStore;
  const { setIsShowBlackLayer } = applicationStore;

  useEffect(() => {
    setIsShowBlackLayer(isShowFreeBetPopup);
  }, [isShowFreeBetPopup, setIsShowBlackLayer]);

  if (!isShowFreeBetPopup) return null;

  return (
    <Container name='FreeBetWrapperContainer'>
      <FreeBet />
    </Container>
  );
});

export default FreeBetWrapper;
